import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter
} from "@angular/core";
import { CommunicationService } from "src/app/services/communication.service";
import { MerchantItems } from "src/app/models/items";
import { timeout } from "rxjs/operators";
import { TimeoutError, Subscription } from "rxjs";
import { GeneralService } from "src/app/services/general.service";
import { CommunicationCommand } from "src/app/models/communicationCommands";
import * as localForage from "localforage";
import { MockStoreService } from "src/app/services/mock-store.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-items-selection-view",
  templateUrl: "./items-selection-view.component.html",
  styleUrls: ["./items-selection-view.component.css"]
})
export class ItemsSelectionViewComponent implements OnInit, OnDestroy {
  @Output("closeSelectedComponent")
  closeSelectedComponent = new EventEmitter();
  @Output("selectionDone") selectionDone = new EventEmitter();
  loading: boolean = false;
  selectionMode: boolean = false;
  private destroyItems: Array<Subscription> = [];
  itemsList: MerchantItems[] = [];
  itemsSelected: MerchantItems[] = [];
  noCatalogueOrNoResponse: string;
  anchorText: string;
  public searchText: string;

  constructor(
    private commservice: CommunicationService,
    private mockstore: MockStoreService,
    private generalservice: GeneralService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.destroyItems[0] = this.generalservice.startFetchingSelectionItems$.subscribe(
      val => {
        if (val.length < 1) return;
        this.getAllItemsOfMerchant();
      }
    );
    // this observer listens for command to show selection
    this.destroyItems[1] = this.generalservice.addItemsFromCatalogueListing$.subscribe(
      val => {
        if (val.length < 1) return;
        // console.log(this.mockstore.comingFromCatalogueListingComponent);
        // console.log(this.mockstore.addingDirectlyFromCatalogueListing);
        this.generalservice.successNotification(
          `Note that you can only add ${this.mockstore.addingDirectlyFromCatalogueListing} items`
        );
      }
    );
  }

  getAllItemsOfMerchant() {
    this.itemsList = [];
    this.itemsSelected = [];
    this.loading = true;
    this.commservice
      .fetchAllItems()
      .pipe(timeout(50000))
      .subscribe(
        val => {
          // clear the storage of anything selecteditem

          const { data } = val;
          this.itemsList = [...data];
          if (this.itemsList.length < 1) {
            this.noCatalogueOrNoResponse = "We could not find any items.";
            this.anchorText = "Add items now";
          }
          this.loading = false;
        },
        err => {
          if (err instanceof TimeoutError) {
            this.loading = false;
            this.generalservice.errorNotification(
              "Please check your internet connection and try again!"
            );
            this.noCatalogueOrNoResponse = "We could not find any items.";
            this.anchorText = "Try again";
            return;
          }

          this.loading = false;
          this.generalservice.errorNotification("Failed to fetch your items!");
          this.noCatalogueOrNoResponse = "We could not find any items.";
          this.anchorText = "Try again";
        }
      );
  }

  selectThisItem(event: Event) {
    const input = event.srcElement as HTMLInputElement;
    if (
      input.checked &&
      typeof this.mockstore.addingDirectlyFromCatalogueListing == "number" &&
      this.mockstore.addingDirectlyFromCatalogueListing > 0 &&
      this.itemsSelected.length ==
        this.mockstore.addingDirectlyFromCatalogueListing
    ) {
      input.checked = false;
      this.generalservice.warningNotification(
        `You can only select ${this.mockstore.addingDirectlyFromCatalogueListing} items`
      );
      this.itemsSelected = this.itemsSelected.slice(
        0,
        this.mockstore.addingDirectlyFromCatalogueListing
      );
      return;
    }
    if (this.itemsSelected.length >= 10) {
      this.itemsSelected = this.itemsSelected.slice(0, 10);
      input.checked = false;
      this.generalservice.warningNotification(
        "You can only select 10 items per catalogue"
      );
      return;
    }
    if (input.checked) {
      const item = this.itemsList.find(
        element => element.id.toString() == input.id
      );
      this.itemsSelected.push(item);
    } else {
      this.itemsSelected = this.itemsSelected.filter(
        element => element.id.toString() != input.id
      );
    }
  }

  cancel() {
    this.itemsSelected = [];
    this.closeSelectedComponent.emit("close");
  }

  async addSelectedToCatalogue() {
    if (
      this.mockstore.addingDirectlyFromCatalogueListing &&
      this.mockstore.comingFromCatalogueListingComponent
    ) {
      this.generalservice.broadCastMessageToAddItemsDirectlyToCatalogueListing({
        switcher: "close",
        message: this.itemsSelected
      });
      this.mockstore.comingFromCatalogueListingComponent = false;
      this.mockstore.addingDirectlyFromCatalogueListing = undefined;
      return;
    }
    await localForage.removeItem("selectedPictures");
    const comm = new CommunicationCommand("open", "", "catalogue");
    await localForage.setItem("selectedPictures", this.itemsSelected);
    this.closeSelectedComponent.emit("close");
    this.selectionDone.emit(comm);
    this.itemsSelected = [];
  }

  takeAction(event: Event) {
    const anchor = event.srcElement as HTMLAnchorElement;
    if (anchor.innerText.includes("Try again")) {
      this.getAllItemsOfMerchant();
    } else {
      this.closeSelectedComponent.emit("close");
      this.router.navigate(["items"], {
        queryParams: { redirect: "catalogue" }
      });
    }
  }

  // this was not working in the template
  get showEmptyBox() {
    return !this.loading && this.itemsList.length < 1;
  }

  ngOnDestroy() {
    this.destroyItems.forEach(element => element.unsubscribe());
  }
}
